<template>
  <BaseElFormItem>
    <div class="container">
      <div class="flex items-center justify-end" style="margin-bottom: 8px">
        <div class="flex items-center" style="gap: 20px">
          <div>
            <BaseElButton class="move-layer-btn" type="text" @click="$emit('upLayer')">
              上移一層<i class="el-icon-top el-icon--right" />
            </BaseElButton>
            <BaseElButton class="move-layer-btn" type="text" @click="$emit('downLayer')">
              下移一層<i class="el-icon-bottom el-icon--right" />
            </BaseElButton>
          </div>
          <BaseElButton class="remove-btn" type="text" @click="$emit('remove')">
            刪除<i class="el-icon-delete-solid el-icon--right" />
          </BaseElButton>
        </div>
      </div>
      <BaseElInput
        v-model="syncData.text"
        type="textarea"
        :autosize="{ minRows: 3, maxRows: 4}"
        placeholder="請輸入"
      />
    </div>
  </BaseElFormItem>
</template>

<script>
import { defineComponent } from 'vue'
import { useVModel } from '@vueuse/core'

export default defineComponent({
  name: 'ContentBlockEditBlock',
  props: {
    data: { type: Object, default: () => ({}) },
  },
  setup (props, { emit }) {
    const syncData = useVModel(props, 'data', emit)
    return { syncData }
  },
})
</script>

<style lang="postcss" scoped>
.container {
  @apply bg-gray-20 rounded-[8px] px-[12px] py-[20px] max-w-[560px];
}

.move-layer-btn {
    @apply border-solid border-[1px] border-primary-100 py-[5px] px-[8px] text-sm;
  }

  .remove-btn {
    @apply border-solid border-[1px] border-danger py-[5px] px-[8px] text-sm text-danger;
  }
  ::v-deep .el-textarea {
    @apply w-full;
  }
</style>
